import { render } from "./DocumentStatusIcons.vue?vue&type=template&id=05d8a87e&scoped=true"
import script from "./DocumentStatusIcons.vue?vue&type=script&lang=js"
export * from "./DocumentStatusIcons.vue?vue&type=script&lang=js"

import "./DocumentStatusIcons.vue?vue&type=style&index=0&id=05d8a87e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d8a87e"]])

export default __exports__